import React from 'react'

const Landscape = () => {
    return (
        <div className='page-height'>
            Landscape - COMING SOON
        </div>
    )
}

export default Landscape